const payment_list = {
  title: '課金管理',
  search_payment_placeholder: '検索',
  id: '順番',
  coach_name: 'コーチ名',
  graduation: '卒業期',
  student_name: '連携氏名',
  student_email: '連携メールアドレス',
  phone: '連携電話番号',
  plan_name: 'プラン名',
  charge_time: '課金時間',
  status: 'ステータス',
  payment_success: '成功',
  payment_fail: '失敗',
  modal: {
    title: '課金詳細',
    student_name: '連携氏名',
    student_email: '連携メールアドレス',
    phone: '携帯電話',
    plan_name: '利用プラン',
    graduation: '卒業期',
    status: 'ステータス',
    close_button: 'キャンセル',
  },
  csv_upload: 'CSVアップロード',
  csv_output: 'データ出力',
};

export default payment_list;
